module.exports = __webpack_public_path__ + "img/helper@3x.6388fe0b.png";